require( './bootstrap' );

import LazyLoad from "vanilla-lazyload";


document.addEventListener(
    'DOMContentLoaded',
    function () {
        let myLazyLoad = new LazyLoad( {
            elements_selector: ".lazy-load"
        } );
    }
);

!function(){"use strict";var e,t;function n(e,t){e.classList?e.classList.add(t):e.className+=" "+t}e=document.createElement("button",{id:"m_btn"}),t=document.getElementById("h_menu"),n(e,"h-menu__btn"),e.textContent="Меню",t&&(t.insertBefore(e,t.firstChild),e.addEventListener("click",function(){!function(e,t){if(e.classList)e.classList.toggle(t);else{var n=e.className.split(" "),o=n.indexOf(t);o>=0?n.splice(o,1):n.push(t),e.className=n.join(" ")}}(t,"active")})),function(){var e,t=document.getElementById("loadmore");t&&(e=t.textContent,t.addEventListener("click",function(){t.disabled=!0,t.textContent="Load...";var n=new XMLHttpRequest;n.open("POST",ajaxurl+"?action=loadmore&query="+true_posts+"&page="+current_page,!0),n.send(),n.onload=function(){if(n.status>=200&&n.status<400){var o=n.responseText;if(o&&"0"!==o){var s=document.createElement("div");for(s.innerHTML=o;s.firstChild;){var a=s.removeChild(s.firstChild);t.parentNode.parentNode.insertBefore(a,t.parentNode)}current_page==max_pages&&(t.parentNode.style.display="none"),current_page++,t.textContent=e,t.disabled=!1}else t.parentNode.style.display="none",console.log("No response...")}else console.log("Error...")},n.onerror=function(){console.log("Connection Error...")}}))}(),function(){document.body;var e=document.getElementById("js_top");function t(){var e=Date.now(),t=setInterval(function(){var n=Date.now()-e,o=window.pageYOffset||document.documentElement.scrollTop;n>=5e3||o<=0?clearInterval(t):function(e,t,n){if(n>0){var o=n-n*e/(2*t);window.scrollTo(0,o)}}(n,5e3,o)},10)}e&&(window.onscroll=function(){var o,s;(window.pageYOffset||document.documentElement.scrollTop)>.5*window.innerHeight?(n(e,"active"),e.addEventListener("click",t)):(s="active",(o=e).classList?o.classList.remove(s):o.className=o.className.replace(new RegExp("(^|\\b)"+s.split(" ").join("|")+"(\\b|$)","gi")," "),e.removeEventListener("click",t))})}()}();

(function() {
    'use strict';
    //--------------------------------------------------------------------------------------------------------------
    //	MOBILE MENU INIT
    //--------------------------------------------------------------------------------------------------------------
    (function(){
        let btn = document.createElement('button', {id: "m_btn"}),
            menu = document.getElementById('h_menu');
        addClass(btn, 'h-menu__btn');
        btn.textContent = 'Меню';
        if (menu){
            menu.insertBefore(btn, menu.firstChild);
            btn.addEventListener('click', function(){
                toggleClass(menu, 'active');
            });
        }
    })();
    //--------------------------------------------------------------------------------------------------------------
    //	LOADMORE SCRIPT
    //--------------------------------------------------------------------------------------------------------------
    (function(){
        let btn = document.getElementById('loadmore');
    
        if(btn) loadMore();
    
        function loadMore(){
            let btn_text = btn.textContent;
    
            btn.addEventListener('click', function(){
                btn.disabled = true;
                btn.textContent = 'Load...';
                   let request = new XMLHttpRequest();
                request.open('POST', ajaxurl+'?action=loadmore&query='+true_posts+'&page='+current_page, true);
                request.send();
                request.onload = function() {
                    if (request.status >= 200 && request.status < 400) {
                        let resp = request.responseText;
                        if( resp && resp !== '0') {
                            let div = document.createElement("div");
                            div.innerHTML = resp;
                            while ( div.firstChild ) {
                                let item = div.removeChild( div.firstChild );
                                btn.parentNode.parentNode.insertBefore(item, btn.parentNode);
                            }
                            if (current_page === max_pages ) btn.parentNode.style.display = 'none';// если последняя страница, скрываем кнопку
                            current_page++; // увеличиваем номер страницы на единицу
                            btn.textContent = btn_text;
                            btn.disabled = false;
                        } else {
                            btn.parentNode.style.display = 'none';
                            console.log('No response...');
                        }
        
                    }
                };
            });
        }
    })();
    //--------------------------------------------------------------------------------------------------------------
    //	SCROLL TO TOP
    //--------------------------------------------------------------------------------------------------------------
    (function(){
        let body = document.body,
            up_button = document.getElementById('js_top');
        
        if (up_button){
            window.onscroll = function() {
                let scrolled = window.pageYOffset || document.documentElement.scrollTop,
                    h = window.innerHeight;
                if (scrolled > 0.5*h) {
                    addClass(up_button, 'active');
                    up_button.addEventListener('click', scrollToTop);
                }
                else {
                    removeClass(up_button, 'active');
                    up_button.removeEventListener('click', scrollToTop);
                }
            };
        }

        function scrollToTop() {
            let start = Date.now();
            let timer = setInterval(function() { 
            let timePassed = Date.now() - start;
            let time = 5000;
            let scrolled = window.pageYOffset || document.documentElement.scrollTop;  
                if (timePassed >= time || scrolled <= 0) {
                clearInterval(timer);
                return;
                }
                up (timePassed,time,scrolled);
            }, 10);

            function up(timePassed,time,scrolled) {
                if (scrolled > 0) {
                    let x = scrolled - (scrolled*timePassed/(2*time));
                    window.scrollTo(0,x); 
                }
            }
        }	
    })();

    //--------------------------------------------------------------------------------------------------------------
    //	HELPERS
    //--------------------------------------------------------------------------------------------------------------
    function addClass(el, className) {
        if (el.classList)
            el.classList.add(className);
        else
            el.className += ' ' + className;
    }

    function removeClass(el, className) {
        if (el.classList)
            el.classList.remove(className);
        else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    function toggleClass(el, className){
		if (el.classList) {
			el.classList.toggle(className);
		} else {
			let classes = el.className.split(' ');
			let existingIndex = classes.indexOf(className);
		  
			if (existingIndex >= 0)
			  classes.splice(existingIndex, 1);
			else
			  classes.push(className);
		  
			el.className = classes.join(' ');
		}
	}
})();
